import { useIsAuth } from 'feature/auth/hooks'
import { FC, Suspense } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router'

import { Loading } from './Loading'

const AUTH_PAGES = [
  '/login',
  '/registration',
  '/company/login',
  '/company/registration',
  '/company/email/login',
]

// обертка для паблик маршрутов
export const PublicRoute: FC = () => {
  const isAuth = useIsAuth()
  const location = useLocation()

  // Авторизованный пользователь не должен попадать на страницы входа/регистрации.
  // Исключение: если есть sendingForm — пользователь пришёл с незавершённым заказом,
  // даём Login/Registration обработать отправку формы перед уходом со страницы.
  if (
    isAuth &&
    AUTH_PAGES.includes(location.pathname) &&
    !location.state?.sendingForm
  ) {
    return <Navigate to='/' replace />
  }

  return (
    <Suspense fallback={<Loading />}>
      <Outlet />
    </Suspense>
  )
}
